'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

var _button = require('../button');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var ConsoleButton = (_temp = _class = function (_M$BaseComponent) {
  _inherits(ConsoleButton, _M$BaseComponent);

  function ConsoleButton(props) {
    _classCallCheck(this, ConsoleButton);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ConsoleButton).call(this, props));

    Object.assign(_this.state, {
      loading: false
    });
    return _this;
  }

  _createClass(ConsoleButton, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var code = _props.code;
      var style = _props.style;
      var data = _props.data;
      var hideIf = _props.hideIf;
      var disabled = _props.disabled;
      var _props$Component = _props.Component;
      var Component = _props$Component === undefined ? _button.Button : _props$Component;
      var requireData = _props.requireData;
      var linkTo = _props.linkTo;
      var linkTarget = _props.linkTarget;
      var loading = this.state.loading;

      var prefixCls = this.props.prefixCls + '-console-button';
      if (hideIf != null && hideIf(data, this.props)) return null;
      var item = Array.isArray(data) ? data[data.length - 1] : data;
      disabled = disabled || requireData && item == null;
      var element = _react2.default.createElement(Component, _extends({
        loading: loading
      }, this.props, {
        className: this.classNames(prefixCls, prefixCls + '_' + code),
        type: style,
        style: undefined,
        disabled: disabled,
        onClick: this.handleClick,
        action: undefined
      }));
      if (!disabled && linkTo != null) {
        var url = _util2.default.template(_util2.default.HashPrefix.format(linkTo), item);
        element = _react2.default.createElement(
          'a',
          { href: url, target: linkTarget || '_self' },
          element
        );
      }
      return element;
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var _this2 = this;

        var _props2 = this.props;
        var onClick = _props2.onClick;
        var data = _props2.data;

        if (onClick == null) return $return(null);
        var ret = onClick.apply(undefined, [data, this.props].concat(_toConsumableArray($args)));

        function $IfStatement_3() {
          return $return();
        }

        if (ret != null && typeof ret.then === 'function') {
          var $Try_1_Finally;
          var $Try_1_Catch;

          var _ret = function () {
            var $Try_1_Post = function $Try_1_Post() {
              return $IfStatement_3.call(this);
            };

            $Try_1_Finally = function ($Try_1_Exit) {
              return function ($Try_1_Value) {
                if (!this._isMounted) {
                  this.setStateAsync({ loading: false });
                }
                return $Try_1_Exit && $Try_1_Exit.call(this, $Try_1_Value);
              }.$asyncbind(this, $error);
            }.$asyncbind(_this2);

            $Try_1_Catch = function ($exception_2) {
              return $Try_1_Finally($error)($exception_2);
            }.$asyncbind(_this2, $Try_1_Finally($error));

            return {
              v: Promise.resolve(_this2.setStateAsync({ loading: true })).then(function ($await_4) {
                try {
                  return Promise.resolve(ret).then(function ($await_5) {
                    return $Try_1_Finally($Try_1_Post).call(this);
                  }.$asyncbind(this, $Try_1_Catch), $Try_1_Catch);
                } catch ($exception_2) {
                  $Try_1_Catch($exception_2)
                }
              }.$asyncbind(_this2, $error), $error)
            };
          }();

          if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
        }
        return $IfStatement_3.call(this);
      }.$asyncbind(this));
    }
  }]);

  return ConsoleButton;
}(_util2.default.BaseComponent), _class.defaultProps = {
  prefixCls: 'mt',
  data: undefined,
  onClick: undefined, // 事件操作，function (data, model) { }
  disabled: undefined
}, _temp);
exports.default = ConsoleButton;